import React from "react";
import InformationPage from "components/shared/InformationPage";
import ApiInformationPage from "models/data/api/ApiInformationPage";
import withApollo from "components/higher-order/withApollo";
import PageContainer from 'components/containers/PageContainer'
import { useRecordPageView } from "hooks/analytics/useRecordPageView";

function Terms() {

  useRecordPageView();

  return (
    <PageContainer>
      <InformationPage page={ApiInformationPage.pages.TERMS_OF_USE} />
    </PageContainer>
  );
}

export default withApollo(Terms);